import React from "react";
const ProjectCom = (props) => {
  const width = document.body.clientWidth;
  return (
    <div
      className={`xs:px-1 xs:py-1.5 sm:px-1.5 sm:py-2.5 lg:px-2 lg:py-4 flex justify-between flex-col cursor-pointer xs:h-56 sm:h-60 items-center lg:h-[400px] xl:h-[420px] xs:rounded-lg sm:rounded-xl lg:rounded-[15px] ${props.eventLayout}`}
      style={{
        backgroundColor: props.eventtheme,
        width:
          width < 500
            ? width / 2 - 20
            : width === 1024
            ? width / 4 - 30
            : width === 768
            ? width / 4 - 30
            : width / 4 - 60,
      }}
      onClick={props.onClick}
    >
      <img
        src={props.eventthubmail}
        className={`w-full h-[82%] 2xl:!has-[85%] xs:rounded-lg sm:rounded-xl lg:rounded-[15px] ${props.eventsimgClassName}`}
        alt="eventthubmail"
      />
      <div
        className={`flex justify-center items-center flex-col xs:pt-2 sm:pt-2 lg:pt-5 h-[18%] 2xl:!has-[15%] ${props.eventsTextClassName}`}
      >
        <div className={`${props.maxWClassname} lg:mb-1 lg:max-w-full`}>
          <p
            className={`capitalize text-primary text-center xs:text-xs sm:text-xs line-clamp-2 lg:text-base xs:leading-3 sm:leading-3 lg:leading-5 font-onestBold ${props.textclassName}`}
          >
            {props.eventTitle}
          </p>
        </div>
        <div className="flex items-start xs:gap-x-1 lg:gap-x-2 ">
          <p className="text-primary font-onestRegular xs:text-[10px] line-clamp-2 sm:text-xs lg:text-sm">
            {props.evetDate}
          </p>
          <p className="text-primary font-onestRegular xs:text-[10px] sm:text-xs text-center line-clamp-2 lg:text-sm leading-3">
            {props.eventDis}
          </p>
        </div>
      </div>
    </div>
  );
};
export default ProjectCom;
